import { useServiceChargeStore } from "@/domains/charges/stores/service-charge.store";
import { useChargeTemplateStore } from "@/domains/charges/stores/charge-template.store";
import { getActivePinia } from "pinia";
import { useChatbotStore } from "@/domains/chatbot/stores";
import { useConversationStore } from "@/domains/conversation/stores";
import { useFeatureFlagStore } from "@/domains/feature-flags";
import { useBookingFormStore, useItineraryStore, } from "@/domains/itinerary/stores";
import { useReservationStore } from "@/domains/reservations/stores";
import { useNotificationStore } from "@/domains/notification/stores";
import { useAvailabilityStore } from "@/domains/scheduling/stores/availability.store";
import { useServiceStore } from "@/domains/service/stores/service.store";
import { useCatalogServiceStore } from "@/domains/service/stores/catalog-service.store";
import { useServiceTypesStore } from "@/domains/service/stores/serviceTypes.store";
import { systemConfigService } from "@/domains/shared/services/system-config.service";
import { useOrganizationStore } from "../stores";
export function resetTenantScopedStores() {
    if (!getActivePinia())
        return;
    useServiceStore().$reset();
    useServiceChargeStore().$reset();
    useChargeTemplateStore().$reset();
    useCatalogServiceStore().$reset();
    useServiceTypesStore().$reset();
    systemConfigService.invalidateCache();
    useAvailabilityStore().$reset();
    useConversationStore().$reset();
    useNotificationStore().$reset();
    useChatbotStore().$reset();
    useItineraryStore().$reset();
    useBookingFormStore().$reset();
    useReservationStore().$reset();
    useFeatureFlagStore().resetRuntime();
    useOrganizationStore().clearMemberCache();
    useOrganizationStore().clearBankAccountCache();
    useOrganizationStore().clearBrandThemeCache();
}
